import type { EditorElement, EditorPluginOptions, EditorPluginPropertyOptions } from '../../types';

import type { ComponentType } from 'react';

export const HEADING_ERROR_PLUGIN_ID = 'headingError' as const;
export type HeadingErrorPluginID = typeof HEADING_ERROR_PLUGIN_ID;

export type HeadingErrorPluginElement = Readonly<
  EditorElement & {
    type: HeadingErrorPluginID;
  }
>;

export type HeadingErrorPluginOptions = Readonly<
  EditorPluginOptions & {
    component?: ComponentType<any>;
  }
>;

export type HeadingErrorPluginPropertyOptions = Readonly<
  EditorPluginPropertyOptions &
    HeadingErrorPluginOptions & {
      pluginID: HeadingErrorPluginID;

      component: ComponentType<any>;
      pluginName: string;
    }
>;
